import {Component, Inject, LOCALE_ID} from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';
import {
  DashboardDensity,
  DashboardSettingsService,
} from '@dash/randy/dashboard/services/dashboard-settings.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'randy';

  public theme = 'sofco-theme-dark';

  constructor(private _overlayContainer: OverlayContainer, private dashboardSettings: DashboardSettingsService, @Inject(LOCALE_ID) protected localeId: string) {
    _overlayContainer.getContainerElement().classList.add(this.theme);

    dashboardSettings.dashboardSettings.subscribe(dashboardSettingsTmp => {
      this.theme = dashboardSettingsTmp.theme;
      this.changeTheme(this.theme);
      this.changeDensity(dashboardSettingsTmp.density ?? 0);
    });

    console.log('localize locale', $localize?.locale);
    console.log('localeId', localeId);
  }

  changeTheme(theme: string): void {
    const classPrefix = 'sofco-theme-';

    // 1. HTML root element
    const htmlEl = document.documentElement;
    const existingHtmlClasses = Array.from(htmlEl.classList).filter(cls => cls.startsWith(classPrefix));
    htmlEl.classList.remove(...existingHtmlClasses);
    htmlEl.classList.add(theme);

    // 2. Overlay container (MatDialog, MatMenu, etc.)
    const overlayClasses = this._overlayContainer.getContainerElement().classList;
    const existingOverlayClasses = Array.from(overlayClasses).filter(cls => cls.startsWith(classPrefix));
    overlayClasses.remove(...existingOverlayClasses);
    overlayClasses.add(theme);
  }

  changeDensity(density: DashboardDensity): void {
    const classPrefix = 'sofco-density-';
    const nextClass = density === 0 ? 'sofco-density-0' : `sofco-density-minus-${Math.abs(density)}`;

    const htmlClasses = document.documentElement.classList;
    const existingHtmlClasses = Array.from(htmlClasses).filter(cls => cls.startsWith(classPrefix));
    htmlClasses.remove(...existingHtmlClasses);
    htmlClasses.add(nextClass);

    const overlayClasses = this._overlayContainer.getContainerElement().classList;
    const existingOverlayClasses = Array.from(overlayClasses).filter(cls => cls.startsWith(classPrefix));
    overlayClasses.remove(...existingOverlayClasses);
    overlayClasses.add(nextClass);
  }
}
